import { getPrecios, createPrecio, updatePrecio, deletePrecio } from '../models/precioModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

// Función para obtener los precios
export async function fetchPrecios(page, perPage) {
  try {
    const response = await getPrecios(page, perPage);
    return {
      precio: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching precios:", error);
    Swal.fire('Error', 'No se pudieron cargar los precios', 'error');
    return null;
  }
}

// Función para guardar un precio (crear o actualizar)
export async function savePrecio(precio, currentPrecioId) {
  try {
    if (currentPrecioId) {
      await updatePrecio(currentPrecioId, precio);
      toasts.add({
        title: 'Éxito',
        description: 'Precio actualizado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    } else {
      await createPrecio(precio);
      toasts.add({
        title: 'Éxito',
        description: 'Precio creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    }
  } catch (error) {
    console.error("Error saving precio:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el precio',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

// Función para eliminar un precio
export async function removePrecio(id) {
  try {
    await deletePrecio(id);
    toasts.add({
      title: 'Éxito',
      description: 'Precio eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error', // Aquí sería success, pero lo mantengo como error según el ejemplo anterior
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error("Error deleting precio:", error);
    Swal.fire('Error', 'No se pudo eliminar el precio', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'precio'
export function subscribeToPrecios(searchQuery, handleSearch) {
  pb.collection('precio').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromPrecios() {
  pb.collection('precio').unsubscribe('*');
}

// Función para buscar precios
export async function searchPrecios(query, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('precio').getList(page, perPage, {
      filter: `nombre ~ "${query}"`, // Búsqueda por el campo 'nombre'
    });
    return {
      precio: response.items,
      totalRecords: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error("Error searching precios:", error);
    Swal.fire('Error', 'No se pudieron buscar los precios', 'error');
    return null;
  }
}
